var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (activeBidsClass, artwork, bidButtonClass, bidButtonLabel, bidButtonLink, detailsClass, isClosed, isLiveOpen, isLiveOpenOrClosed, leadingBidder, losingMessage, myActiveBids, reserveMessage, reserveNotMet, saleArtwork, undefined, viewHelpers, winningMessage) {
jade_mixins["bidStatus"] = jade_interp = function(lotStanding, saleArtwork, args){
var block = (this && this.block), attributes = (this && this.attributes) || {};
winningMessage = args && args.winningMessage || 'Highest Bid'
reserveMessage = args && args.reserveMessage || 'Highest Bid'
losingMessage = args && args.losingMessage || 'Outbid'
leadingBidder = lotStanding.is_leading_bidder
reserveNotMet = saleArtwork.reserve_status === 'reserve_not_met'
buf.push("<div class=\"bid-status\">");
if ( leadingBidder && !reserveNotMet)
{
buf.push("<div class=\"bid-status__is-winning\"><p>" + (jade.escape(null == (jade_interp = winningMessage) ? "" : jade_interp)) + "<i class=\"bid-status__arrow-up\"><svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.14 7.05\">\n\t<polygon class=\"cls-1\" points=\"4.07 7.05 0 0 8.14 0 4.07 7.05\"/>\n</svg>\n</i></p></div>");
}
else
{
if ( leadingBidder && reserveNotMet)
{
buf.push("<div class=\"bid-status__is-winning-reserve-not-met\"><p>" + (jade.escape(null == (jade_interp = reserveMessage) ? "" : jade_interp)) + "<i class=\"bid-status__arrow-up\"><svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.14 7.05\">\n\t<polygon class=\"cls-1\" points=\"4.07 7.05 0 0 8.14 0 4.07 7.05\"/>\n</svg>\n</i></p></div>");
}
else
{
buf.push("<div class=\"bid-status__is-losing\"><p>" + (jade.escape(null == (jade_interp = losingMessage) ? "" : jade_interp)) + "<i class=\"bid-status__arrow-down\"><svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.14 7.05\">\n\t<polygon class=\"cls-1\" points=\"4.07 7.05 0 0 8.14 0 4.07 7.05\"/>\n</svg>\n</i></p></div>");
}
buf.push("<div class=\"bid-status__increase-bid\">Increase your max bid to win the lot</div>");
}
buf.push("</div>");
};
jade_mixins["bidBlock"] = jade_interp = function(saleArtwork, bid){
var block = (this && this.block), attributes = (this && this.attributes) || {};
artwork = saleArtwork.artwork
isLiveOpen = saleArtwork.sale.is_live_open
isClosed = saleArtwork.sale.is_closed
isLiveOpenOrClosed = isLiveOpen || isClosed
detailsClass = isLiveOpenOrClosed ? 'my-active-bids-item-details--hide-bid' : 'my-active-bids-item-details'
bidButtonLabel = isLiveOpen ? 'Bid Live' : isClosed ? 'View Lot' : 'Bid'
bidButtonLink = isLiveOpen ? viewHelpers.getLiveAuctionUrl(saleArtwork.sale_id, {isLoggedIn: true}) : artwork.href
bidButtonClass = isLiveOpenOrClosed ? 'my-active-bids-bid-live-button' : 'my-active-bids-bid-button'
buf.push("<a" + (jade.attr("href", artwork.href, true, true)) + "><img" + (jade.attr("src", artwork.image.url, true, true)) + "><div" + (jade.cls([detailsClass], [true])) + "><h4>Lot " + (jade.escape((jade_interp = saleArtwork.lot_label) == null ? '' : jade_interp)) + "</h4><div class=\"my-active-bids-item-artist\"><strong>" + (jade.escape(null == (jade_interp = artwork.artist.name) ? "" : jade_interp)) + "</strong></div>");
if (!( isLiveOpenOrClosed))
{
buf.push("<p>" + (jade.escape((jade_interp = saleArtwork.highest_bid.display) == null ? '' : jade_interp)) + " (" + (jade.escape((jade_interp = saleArtwork.counts.bidder_positions) == null ? '' : jade_interp)) + " Bids)</p>");
}
buf.push("</div></a>");
if (!( isLiveOpenOrClosed))
{
jade_mixins["bidStatus"](bid, bid.sale_artwork);
}
buf.push("<a" + (jade.attr("href", bidButtonLink, true, true)) + (jade.cls(['avant-garde-button-black',bidButtonClass], [null,true])) + ">" + (jade.escape(null == (jade_interp = bidButtonLabel) ? "" : jade_interp)) + "</a>");
};
if ( myActiveBids && myActiveBids.length)
{
buf.push("<ul>");
// iterate myActiveBids
;(function(){
  var $$obj = myActiveBids;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var bid = $$obj[$index];

saleArtwork = bid.sale_artwork
if ( saleArtwork)
{
leadingBidder = bid.is_leading_bidder
reserveNotMet = saleArtwork.reserve_status === 'reserve_not_met'
isLiveOpenOrClosed = saleArtwork.sale.is_live_open || saleArtwork.sale.is_closed
activeBidsClass = (leadingBidder && !reserveNotMet && !isLiveOpenOrClosed) ? ' my-active-bids-winning' : '' 
buf.push("<li" + (jade.attr("data-artwork_id", saleArtwork.id, true, true)) + (jade.cls(['my-active-bids-item',activeBidsClass], [null,true])) + ">");
jade_mixins["bidBlock"](saleArtwork, bid);
buf.push("</li>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var bid = $$obj[$index];

saleArtwork = bid.sale_artwork
if ( saleArtwork)
{
leadingBidder = bid.is_leading_bidder
reserveNotMet = saleArtwork.reserve_status === 'reserve_not_met'
isLiveOpenOrClosed = saleArtwork.sale.is_live_open || saleArtwork.sale.is_closed
activeBidsClass = (leadingBidder && !reserveNotMet && !isLiveOpenOrClosed) ? ' my-active-bids-winning' : '' 
buf.push("<li" + (jade.attr("data-artwork_id", saleArtwork.id, true, true)) + (jade.cls(['my-active-bids-item',activeBidsClass], [null,true])) + ">");
jade_mixins["bidBlock"](saleArtwork, bid);
buf.push("</li>");
}
    }

  }
}).call(this);

buf.push("</ul>");
}
else
{
buf.push("Nothing yet.");
}}.call(this,"activeBidsClass" in locals_for_with?locals_for_with.activeBidsClass:typeof activeBidsClass!=="undefined"?activeBidsClass:undefined,"artwork" in locals_for_with?locals_for_with.artwork:typeof artwork!=="undefined"?artwork:undefined,"bidButtonClass" in locals_for_with?locals_for_with.bidButtonClass:typeof bidButtonClass!=="undefined"?bidButtonClass:undefined,"bidButtonLabel" in locals_for_with?locals_for_with.bidButtonLabel:typeof bidButtonLabel!=="undefined"?bidButtonLabel:undefined,"bidButtonLink" in locals_for_with?locals_for_with.bidButtonLink:typeof bidButtonLink!=="undefined"?bidButtonLink:undefined,"detailsClass" in locals_for_with?locals_for_with.detailsClass:typeof detailsClass!=="undefined"?detailsClass:undefined,"isClosed" in locals_for_with?locals_for_with.isClosed:typeof isClosed!=="undefined"?isClosed:undefined,"isLiveOpen" in locals_for_with?locals_for_with.isLiveOpen:typeof isLiveOpen!=="undefined"?isLiveOpen:undefined,"isLiveOpenOrClosed" in locals_for_with?locals_for_with.isLiveOpenOrClosed:typeof isLiveOpenOrClosed!=="undefined"?isLiveOpenOrClosed:undefined,"leadingBidder" in locals_for_with?locals_for_with.leadingBidder:typeof leadingBidder!=="undefined"?leadingBidder:undefined,"losingMessage" in locals_for_with?locals_for_with.losingMessage:typeof losingMessage!=="undefined"?losingMessage:undefined,"myActiveBids" in locals_for_with?locals_for_with.myActiveBids:typeof myActiveBids!=="undefined"?myActiveBids:undefined,"reserveMessage" in locals_for_with?locals_for_with.reserveMessage:typeof reserveMessage!=="undefined"?reserveMessage:undefined,"reserveNotMet" in locals_for_with?locals_for_with.reserveNotMet:typeof reserveNotMet!=="undefined"?reserveNotMet:undefined,"saleArtwork" in locals_for_with?locals_for_with.saleArtwork:typeof saleArtwork!=="undefined"?saleArtwork:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"viewHelpers" in locals_for_with?locals_for_with.viewHelpers:typeof viewHelpers!=="undefined"?viewHelpers:undefined,"winningMessage" in locals_for_with?locals_for_with.winningMessage:typeof winningMessage!=="undefined"?winningMessage:undefined));;return buf.join("");
};
module.exports = template;